import { render, staticRenderFns } from "./WDClient.vue?vue&type=template&id=1de3fb7c&"
import script from "./WDClient.vue?vue&type=script&lang=js&"
export * from "./WDClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports